



















































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import {InventoryItem, Room} from '@/store/types'
import ListItem from '@/components/common/ListItem.vue'
import FontAwesome from '@/classes/FontAwesome'
const {SwipeList, SwipeOut} = require('vue-swipe-actions')
import Fuse from 'fuse.js'

@Component({
  components: {
    ListItem,
    SwipeList,
  },
})
export default class InventoryItemsList extends Vue {
  @Getter('roomInventory') public roomInventory!: InventoryItem[]
  @Getter('inventory') public inventory!: InventoryItem[]
  @Getter('activeRoomId') public activeRoomId!: number
  @Getter('activeRoom') public activeRoom!: Room
  @Mutation('setActiveItem') public setActiveItem!: any
  @Mutation('setInventoryEditItemOverlay') public setInventoryEditItemOverlay!: any
  @Action('removeRoomItem') public removeRoomItem!: any

  public FontAwesome = FontAwesome

  public searchText: string = ''
  public $refs: any

  public get filteredItems() {
    if (this.searchText.length) {
      const fuse = new Fuse(this.items, {distance: 100, threshold: 0.2, keys: ['name']})
      const items = fuse.search(this.searchText)
      if (items.length !== undefined) {
        return items
      }
      return
    } else {
      return this.items
    }
  }

  public get activeRoomName() {
    if (this.activeRoom) {
      return this.activeRoom.name.length ? this.activeRoom.name : this.activeRoom.room.name
    }
    return 'All Rooms'
  }

  public get items() {
    return this.activeRoomId ? this.roomInventory : this.inventory
  }

  public get roomVolume() {
    return this.roomInventory.reduce((carry, item) => {
      return carry += item.volume * item.quantity
    }, 0)
  }

  public selectInput() {
    const activeSearch = document.activeElement as HTMLInputElement
    setTimeout(() => {
      activeSearch.selectionStart = activeSearch.selectionEnd = 99999
    }, 1)
  }

  public clearSearch() {
    this.searchText = ''
    this.$refs.search.focus()
  }

  public editItem(item: InventoryItem) {
    this.setActiveItem(item)
    this.setInventoryEditItemOverlay(true)
  }

  @Watch('activeRoomId')
  public onaAtiveRoomIdChanged(id: number) {
    this.searchText = ''
  }
}
